/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es7.promise.finally";
import Vue from 'vue';
import Router from 'vue-router';
import { setTitle } from '@/utils';
import routes from './routes';
Vue.use(Router);
var router = new Router({
  routes: routes
});
router.beforeEach(function (to, from, next) {
  var title = to.meta.title;
  if (title) setTitle(title);
  next();
});
export default router;